/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  TelegramNotificationsPublicControllerUnsubscribeMutationRequest,
  TelegramNotificationsPublicControllerUnsubscribeMutationResponse,
  TelegramNotificationsPublicControllerUnsubscribeQueryParams,
} from '../types/TelegramNotificationsPublicControllerUnsubscribe.ts';

function getTelegramNotificationsPublicUnsubscribeUrl() {
  const res = { method: 'POST', url: `/api/telegram/notifications/unsubscribe` as const };
  return res;
}

/**
 * {@link /api/telegram/notifications/unsubscribe}
 */
export async function telegramNotificationsPublicUnsubscribe(
  data?: TelegramNotificationsPublicControllerUnsubscribeMutationRequest,
  params?: TelegramNotificationsPublicControllerUnsubscribeQueryParams,
  config: Partial<RequestConfig<TelegramNotificationsPublicControllerUnsubscribeMutationRequest>> & {
    client?: typeof fetch;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    TelegramNotificationsPublicControllerUnsubscribeMutationResponse,
    ResponseErrorConfig<Error>,
    TelegramNotificationsPublicControllerUnsubscribeMutationRequest
  >({
    method: 'POST',
    url: getTelegramNotificationsPublicUnsubscribeUrl().url.toString(),
    params,
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}
